export default __webpack_public_path__ + "static/media/spicy.be9c9480.png";